// extracted by mini-css-extract-plugin
export default {"wrapper":"BoothNumber_wrapper__nE7Yh","divider":"BoothNumber_divider__Df22u","booth_number":"BoothNumber_booth_number__0PYTw"};